import { type User } from "@/services/user";
import { BuildMode } from "@/types";

export enum EventName {
  Messaging_IWantToTalkClick = "mkt_messages-funnel-click",
  Messaging_ConversationStarted = "mkt_messages-funnel-first-message",
  Messaging_FirstReaction = "mkt_messages-funnel-first-reaction",
  AiIdentification_Requested = "dev_ai_identification_request",
  AiIdentification_Completed = "dev_ai_vision_identification_completed",
  AiIdentification_Successful = "dev_ai_identification_successful",
  AiIdentification_Unsuccessful = "dev_ai_identification_unsuccessful  ",
  AiIdentification_ItemCreated = "dev_ai_vision_item_created",
  AiIdentification_IWantToTryClick = "mkt_ai_vision_i_want_to_try",
  AiIdentification_LimitedPopupShown = "mkt_ai_vision_limited_popup_shown",
  AiIdentification_SaveIntoCollectionClick = "mkt_ai_vision_save_into_collection_click",
  AiIdentification_NextIdentificationClick = "mkt_ai_vision_next_identification_click",
  AiIdentification_UnauthorizedError = "mkt_ai_vision_unauthorized_error",
  AiIdentification_DashboardBannerClick = "mkt_ai_vision_dashboard_banner_click",
  BestDeals_ExitClick = "dev_bestdeals_exit_click",
  BestDeals_MoreClick = "dev_bestdeals_more_click",
  BestDeals_OutsideClick = "dev_bestdeals_outside_click",
  BestDeals_FakeOrderClick = "dev_bestdeals_fakeorder_click",
  BestDeals_BannerClick = "mkt_bestdeals_banner_cta",
  BestDeals_WatchdogDialog_Open = "mkt_bestdeals_watchdog_wishlist_open",
  BestDeals_WatchdogDialog_Send = "mkt_bestdeals_watchdog_wishlist_send",
  ShowPricesSettingsChange = "dev_user_show_prices",
  EmailNotVerifiedDialog = "dev_registration_verify_email",
}

export type PostHogObject = {
  capture: (...args: unknown[]) => void;
  identify: (id: string) => void;
};

export const trackEvent = async (event: EventName, params?: Record<string, string | number | boolean /* feel free to extend types if needed */>): Promise<void> => {
  if (isTrackingAllowed()) {
    getPostHogObject()?.capture(event, params);
  }
};

export const identifyUser = async (user: User): Promise<void> => {
  if (isTrackingAllowed()) {
    getPostHogObject()?.identify(user.email);
  }
};

const isTrackingAllowed = (): boolean => {
  const allowedModes = [BuildMode.production, BuildMode.beta];
  const mode = import.meta.env.MODE as BuildMode;
  return allowedModes.includes(mode);
};

const getPostHogObject = (): PostHogObject | undefined => {
  if (typeof window.posthog === "undefined") {
    console.warn("DEV: Should not happen. PostHog not found.");
    return undefined;
  } else {
    return window.posthog;
  }
};
